import { inject, Injectable } from '@angular/core';
import { Actions, createEffect } from '@ngrx/effects';
import { switchMap } from 'rxjs';

import { ofSignalType } from '@locumsnest/core/src';

import { AuthGroupService } from './auth-group.service';
import { InitializeAuthGroupSignal } from './auth-group.signals';

@Injectable()
export class AuthGroupEffects {
  private authGroupService = inject(AuthGroupService);
  private actions$ = inject(Actions);

  initializeCurrentUserPermissions$ = createEffect(() =>
    this.actions$.pipe(
      ofSignalType(InitializeAuthGroupSignal),
      switchMap(() => this.authGroupService.load()),
    ),
  );
}
